import { Observable, Subject } from 'rxjs';
import BroadcastWorker from 'workers/broadcast.worker.js?worker';

type BroadcastServiceEvents = {
  codeframesUpdated: undefined;
};

class BroadcastService {
  private readonly worker = new BroadcastWorker();
  private subjects: {
    [key in string]: Subject<any>;
  } = {};

  constructor() {
    this.worker.postMessage({
      type: 'INIT_CHANNEL',
    });
  }

  public produce = <E extends keyof BroadcastServiceEvents>(
    event: E,
    payload?: BroadcastServiceEvents[E]
  ) => {
    this.worker.postMessage({
      type: 'SEND_MESSAGE',
      data: {
        event,
        payload,
      },
    });
  };

  public $listen = <E extends keyof BroadcastServiceEvents, P extends BroadcastServiceEvents[E]>(
    event: E
  ): Observable<P> => {
    if (this.subjects[event]) return this.subjects[event].asObservable();
    const $s = new Subject<P>();
    this.subjects[event] = $s;
    this.worker.addEventListener('message', (ev) => {
      (ev.data.data.event as any) === event && $s.next(ev.data.data.payload);
    });
    return $s.asObservable() as Observable<P>;
  };
}

const broadcast = new BroadcastService();

export { broadcast };
